import React, { useState } from 'react';
import { PocTooltip } from 'commons/components/components-wrapper';
import { ListItem, ListItemProps } from './list-item.component';
import { Placement } from '@one/web-components';

export interface ListItemData extends ListItemProps {
    tooltipText?: string;
    tooltipPlacement?: Placement;
}

interface ListProps {
    items: ListItemData[];
    wrapper?: React.ComponentType<{ children: React.ReactNode }> | null;
}

export const List: React.FC<ListProps> = ({ items, wrapper: Wrapper }) => {
    const [hoveredItemId, setHoveredItemId] = useState<string | null>(null);

    const content = items.map((item) => {
        const hasTooltip = Boolean(item?.tooltipText);
        const handlers = hasTooltip
            ? {
                  onMouseEnter: () => setHoveredItemId(item.id),
                  onMouseLeave: () => setHoveredItemId((current) => (current === item.id ? null : current)),
              }
            : {};

        const { tooltipText, tooltipPlacement, ...listItemProps } = item;

        return (
            <div key={item.id} {...handlers} id={item.id}>
                <ListItem {...listItemProps} />
                {hasTooltip && (
                    <PocTooltip
                        anchor={item.id}
                        visible={hoveredItemId === item.id}
                        placement={tooltipPlacement ?? 'bottom'}
                        leaveDuration={0}
                    >
                        {tooltipText}
                    </PocTooltip>
                )}
            </div>
        );
    });

    return Wrapper ? <Wrapper>{content}</Wrapper> : <>{content}</>;
};
